function toCsvValue(v) {
  if (v === null || v === undefined) return "";
  const s = typeof v === "object" ? JSON.stringify(v) : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Downloads an array of row-objects as a CSV file (client-side, no backend round trip). */
export function exportTableToCsv(rows, filename) {
  if (!Array.isArray(rows) || rows.length === 0) return;
  const columns = Array.from(rows.reduce((set, row) => {
    Object.keys(row || {}).forEach((k) => set.add(k));
    return set;
  }, new Set()));

  const lines = [columns.join(",")];
  rows.forEach((row) => {
    lines.push(columns.map((c) => toCsvValue(row[c])).join(","));
  });

  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  URL.revokeObjectURL(url);
}
